import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Inspection, InspectionAssignment, InspectionFee, InspectionResult, InspectionStatuses as IST, InspectionTypes as ITPS,
  OffsiteFacility, OffsiteFacilityTypes } from '../shared/models/Inspection';
import { InspectionService } from '../shared/services/inspection.service';
import { PreviewModalService } from '../../shared/services/preview-modal.service';
import { SubDataVariables } from '../../../environments/app.variables';
import { environment } from '../../../environments/environment';
import { DocumentDetail } from '../../models/ApplicationDetail';
import { DocumentRef } from '../../models/DocumentRef';
import { CheckListValueModel, Document } from '../../models/ApplicationModel';
import * as Constants from '../../models/Constants';
import {saveAs} from 'file-saver';
import { CommonService } from '../../shared/services/common.service';
import { AlertService } from '../../shared/services/alert.service';

@Component({
  selector: 'app-inspection-detail-readonly',
  templateUrl: './inspection-detail-readonly.component.html',
  styleUrls: ['./inspection-detail-readonly.component.css']
})
export class InspectionDetailReadonlyComponent implements OnInit, AfterViewInit {

  public inspectionId: number;
  public inspection: Inspection;
  public detailReady: boolean = false;
  public activeTab: string;
  public inspectionStatuses: any = IST;
  public showDocumentsTab: boolean = false;
  public showChecklistTab: boolean = false;
  public showGMPSuspensionLetter: boolean = false;
  public showGMPCancellationLetter : boolean = false;
  public showGMPRevocationLetter : boolean = false;
  public noCapa: boolean = false;
  public inspectionDocUploadUrl = environment.baseUrl + '/Attachment/Inspection';
  public uploadErrorMessage: string;
  public documents: Array<Document> = [];
  public editDocuments: Array<DocumentDetail> = [];
  public documentRefs: Array<DocumentRef> = [];
  public uploadedFinalDocuments: Array<DocumentRef> = [];
  public capaDocRefs:Array<DocumentRef> = [];
  public implementationDocRefs:Array<DocumentRef> = [];
  public paymentDocRefs: Array<DocumentRef> = [];
  public finalFileDocRefs: Array<DocumentRef> = [];
  public inspectionDocRefs: Array<DocumentRef> = [];
  public serviceFeeReference: DocumentRef;
  public attachedDocs: Array<any> = [];
  public isAbroadCGMP: boolean = false;
  public isLocalGMP: boolean = false;
  public isAbroadWaiver: boolean = false;
  public isGMP : boolean = false;
  public historyLog: any;
  public inspectionListUrl: string = "";
  public constants: any = Constants;
  public showEnketoForm = false;
  public currentInspectionResult = null;
  public showFileColumnsInspectionResult: boolean;
  public showOdkColumnsInspectionResult: boolean;
  public inspectionResults: InspectionResult[];
  public inspectionResultDocuments: any[];
  public isSra: boolean = false;
  public multipleFacilityFees: InspectionFee[] = [];
  public productionLineCount: number = 0;
  public moreThan2ProdLineFees: InspectionFee;
  public totalAppliedFeeAmount: number = 0;
  public paymentAddrFee:InspectionFee;
  public sraFee: InspectionFee;
  public multipleOffsiteFacilityFee: InspectionFee;
  public categoryId : number = 0;
  public agencyId : number = 0;
  public applicantTypeId : number = 0;
  public isGMPFinalPayment: boolean = false;
  public showSubmittedFinalDocuments: boolean = false;
  public itps = ITPS;
  public keyPersons: any[] = []; //keypersons of abroad facility\
  public modalRef: any;
  public expandedProdDetailIds: number[] = [];
  public offsiteFacilityTypes: any = OffsiteFacilityTypes;
  public totalOffsiteFacilities: OffsiteFacility[] = [];
  public uniqueOffsiteFacilitiesByNameAndAddressCount : number = 0;
  constructor(private route: ActivatedRoute, private inspectionService: InspectionService,
    private previewService: PreviewModalService, private commonService : CommonService,
    private alertService: AlertService) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.route.params.subscribe(params => {
      this.inspectionId = params['id'];
      this.getInspection();
      this.getInspectionHistory(this.inspectionId);
    });
  }

  activateTab(tab) {
    this.activeTab = tab;
    $('.nav-tabs a[href="#' + tab + '"]').tab('show');
  };

  getInspection(){
    this.inspectionService.getInspection(this.inspectionId).subscribe(resp => {
      if (!resp) {
        this.alertService.error('Unable to load inspection ' + this.inspectionId + '. The API returned no data.');
        return;
      }
      this.inspection = resp;
      this.inspection.documents = (this.inspection.documents || []).sort((a, b) => b.id - a.id);
      this.categoryId = resp.productionInfo?.approvalMethodID;
      this.agencyId = resp.productionInfo?.agencyID;
      if(resp.inspectionAbroadFacility?.length > 0) {
        this.applicantTypeId = resp.inspectionAbroadFacility[0].applicantTypeID
      } else if (resp.userDto?.applicantTypeId) {
        this.applicantTypeId = resp.userDto.applicantTypeId;
      }

      if(this.inspection.productionInfo && this.inspection.productionInfo.productDetails?.length > 0) {
        var prodDetails = this.inspection.productionInfo.productDetails;
        const { totalOffsiteFacilities, uniqueOffsiteFacilitiesByNameAndAddressCount } =
            this.inspectionService.getOffsiteFacilitiesInfo(prodDetails)
        this.totalOffsiteFacilities = totalOffsiteFacilities;
        this.uniqueOffsiteFacilitiesByNameAndAddressCount = uniqueOffsiteFacilitiesByNameAndAddressCount;
      }

      this.inspectionListUrl = this.inspectionService.getInspectionListUrl(this.inspection);
      this.inspection.inspectionNumber = '0'.repeat(Math.max(5, this.inspection.id.toString().length) - this.inspection.id.toString().length) + this.inspection.id +
                                            this.inspection.inspectionNumber;

      if(this.inspection.previousInspectionID){
        this.inspection.previousInspectionNumber = '0'.repeat(Math.max(5, this.inspection.previousInspectionID.toString().length) - this.inspection.previousInspectionID.toString().length) +
                    this.inspection.previousInspectionID + this.inspection.previousInspectionNumber;
      }

      this.isAbroadCGMP = [ITPS.NEW_ABROAD_CGMP_INSPECTION, ITPS.NEW_ABROAD_CGMP_INSPECTION_WAIVER,ITPS.ABROAD_CGMP_RENEWAL_INSPECTION,
         ITPS.ABROAD_CGMP_INSPECTION_WAIVER_RENEWAL, ITPS.ABROAD_CGMP_LINE_ADDITION_INSPECTION].indexOf(this.inspection.type.inspectionTypeCode) !== -1;

      this.isLocalGMP = [ITPS.LOCAL_GMP_RENEWAL_INSPECTION, ITPS.NEW_LOCAL_GMP_INSPECTION].indexOf(this.inspection.type.inspectionTypeCode) !== -1;

      this.isAbroadWaiver = [ITPS.NEW_ABROAD_CGMP_INSPECTION_WAIVER, ITPS.ABROAD_CGMP_INSPECTION_WAIVER_RENEWAL].indexOf(this.inspection.type.inspectionTypeCode) != -1;

      this.isGMP = this.isAbroadCGMP || this.isLocalGMP;

      this.detailReady = true;
      this.attachedDocs = this.inspection.documents;
      if (this.inspection.inspectionAbroadFacility?.length > 0) {
        this.activateTab('abroadFacilityInfo');
      } else if (this.inspection.productionInfo) {
        this.activateTab('productionInfo');
      } else {
        this.activateTab('inspectionInfo');
      }
      this.setActionButtons();
      this.addPaymentLetter()

      if(this.isAbroadCGMP) {
        this.fillKeyPersons();
      }

      this.inspectionService.getAllUserUploadedDocRefs(this.inspection.type.inspectionTypeCode, this.categoryId, this.agencyId, this.applicantTypeId).subscribe(documentRefsResp => {
        for (let i = 0; i < documentRefsResp.length; i++) {
          this.documentRefs.push(documentRefsResp[i]);
          if(documentRefsResp[i].name == Constants.PAYMENT_DOC_NAME && ([IST.SCREENING_PASSED, IST.RECOMMEND_FOR_PAYMENT_FAILURE,IST.PAYMENT_REQUEST_LETTER_GENERATED].indexOf( this.inspection.status.inspectionStatusCode) !== -1 && !this.isLocalGMP)){
            this.paymentDocRefs.push(documentRefsResp[i]);
          } else if(documentRefsResp[i].name == Constants.GMP_FINAL_PAYMENT_DOC_NAME && this.isGMP && this.inspection.status.inspectionStatusCode == IST.FINAL_PAYMENT_REQUESTED){
            this.paymentDocRefs.push(documentRefsResp[i]);
          } else if(documentRefsResp[i].name == Constants.CAPA_DOC_NAME){
            this.capaDocRefs.push(documentRefsResp[i]);
          } else if(documentRefsResp[i].name == Constants.IMPLEMNTATION_REPORT_DOC_NAME){
            this.implementationDocRefs.push(documentRefsResp[i]);
          }
        }

        let emptyDocRefs = this.documentRefs.filter(d => this.inspection.documents.map(m => m.referenceID).indexOf(d.id) == -1 &&
          [Constants.PAYMENT_DOC_NAME, Constants.CAPA_DOC_NAME, Constants.IMPLEMNTATION_REPORT_DOC_NAME].indexOf(d.name) != -1);

        this.documentRefs = this.documentRefs.filter(d => emptyDocRefs.map(m => m.id).indexOf(d.id) == -1);
        this.showDocumentsTab = this.documentRefs.length > 0;
      });

      if(this.showSubmittedFinalDocuments){
          this.uploadedFinalDocuments = this.inspection.documents.filter(d => [Constants.INSPECTION_AGENDA, Constants.CONFLICT_OF_INTEREST, Constants.COUNTRY_REQUIREMENT,
            Constants.VISA, Constants.PREPARATION_CHECKLIST].indexOf(d.documentReference.name) != -1).map(d => d.documentReference);
      }

      if (this.inspection.screeningChecklists.length) {
        this.showChecklistTab = true;
        this.inspection.screeningChecklists.forEach(function (checklist) {
          if (checklist.screenerResponseValue === null) {
            checklist.screenerResponseValue = new CheckListValueModel();
          }
        });
      }

      if(this.inspection.appliedFees && this.inspection.appliedFees.length > 0){
        this.isSra = this.inspection.appliedFees.findIndex(f => f.isSra == true) > -1;
        if(this.isSra){
          this.sraFee = this.inspection.appliedFees.find(f => f.isSra == true);
          this.totalAppliedFeeAmount += this.inspection.appliedFees.find(f => f.isSra == true).amount;
        } else {
          this.paymentAddrFee = this.inspection.appliedFees.find(f => f.isSra == false && f.hasMultipleFacility == false && f.code != 'MTTP' && f.code != 'MOF');
          if(this.paymentAddrFee){
            this.totalAppliedFeeAmount += this.paymentAddrFee.amount;
          }
        }
        this.multipleFacilityFees = this.inspection.appliedFees.filter(f => f.hasMultipleFacility == true);
        this.multipleFacilityFees.forEach(f => this.totalAppliedFeeAmount += f.amount);
        this.moreThan2ProdLineFees = this.inspection.appliedFees.find(f => f.code == 'MTTP');
        if(this.moreThan2ProdLineFees){
          this.productionLineCount = this.inspectionService.countProductionLinesForFee(this.inspection.productionInfo?.productDetails);
          this.totalAppliedFeeAmount += this.moreThan2ProdLineFees.amount * Math.max(0, this.productionLineCount - 2);
        }
        this.multipleOffsiteFacilityFee = this.inspection.appliedFees.find(f => f.code == 'MOF');
        if(this.multipleOffsiteFacilityFee) {
          this.totalAppliedFeeAmount += (this.multipleOffsiteFacilityFee.amount * (this.uniqueOffsiteFacilitiesByNameAndAddressCount));
        }
      }
    });
  }

  getApplicationNumber(selectedFacility) {
    return '0'.repeat(Math.max(5, selectedFacility.applicationID.toString().length) - selectedFacility.applicationID.toString().length) + selectedFacility.applicationID +
        selectedFacility.applicationNumber
  }


  getDateString(inputDate) {
    let date = new Date(inputDate);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric'});
  }

  setActionButtons() {
    let statusCode = this.inspection.status.inspectionStatusCode;
    let inspectionTypeCode = this.inspection.type.inspectionTypeCode

    this.showGMPSuspensionLetter = this.isGMP && statusCode == IST.GMP_SUSPENDED && this.inspection.documents.findIndex(d => d.documentReference.name === Constants.SUSPENSION_LETTER_DOC_NAME) !== -1;
    this.showGMPCancellationLetter = this.isGMP && statusCode == IST.GMP_CANCELLED && this.inspection.documents.findIndex(d => d.documentReference.name === Constants.CANCELLATION_LETTER_DOC_NAME) !== -1;
    this.showGMPRevocationLetter = this.isGMP && statusCode == IST.GMP_REVOKED && this.inspection.documents.findIndex(d => d.documentReference.name === Constants.REVOCATION_LETTER_DOC_NAME) !== -1;

    let finalFileDocs = this.inspection.documents.filter(d => [Constants.INSPECTION_AGENDA, Constants.CONFLICT_OF_INTEREST, Constants.COUNTRY_REQUIREMENT,
      Constants.VISA, Constants.PREPARATION_CHECKLIST].indexOf(d.documentReference.name) != -1);

    if(this.inspection.inspectionResults && this.inspection.inspectionResults.length > 0){
      //for non-gmp don't show the tab for applicant for gmp show the inspection result tab for all roles
      this.inspectionResults = this.inspection.inspectionResults.reverse();
      this.inspectionResults.map(result => {
          if(!this.isGMP) {
            if(result.documentID){
              this.showFileColumnsInspectionResult = true;
              let fileName = result.document.filePath;
              if(fileName){
                fileName = fileName.replace(/^.*[\\\/]/, '');
                !fileName.length ? result.fileName = '-' : result.fileName = fileName;
              }else {
                result.fileName = '-';
              }
            }

            if(result.odkResponseUUID){
              this.showOdkColumnsInspectionResult = true;
            }

            result.inspectionIdentifier = result.inspectionIdentifier || '-';
            result.odkFormUploadDate = result.odkFormUploadDate ? this.getDateString(result.odkFormUploadDate) : '-';
            result.uploadedTime = result.createdDate ? this.getDateString(result.createdDate) : '-';

          } else {

            result.inspectionResultDocuments.map(resultDoc => {
              let fileName = resultDoc.inspectionDocument.filePath;
              if(fileName){
                fileName = fileName.replace(/^.*[\\\/]/, '');
                !fileName.length ? resultDoc.fileName = '-' : resultDoc.fileName = fileName;
              }else {
                resultDoc.fileName = '-';
              }
            });
            result.taskForceReportDocument = result.inspectionResultDocuments.find(d => d.inspectionDocument?.documentReference?.name === Constants.TASK_FORCE_REPORT_DOC_NAME);
            result.inspectionResultDocuments = result.inspectionResultDocuments.filter(d => d.inspectionDocument?.documentReference?.name !== Constants.TASK_FORCE_REPORT_DOC_NAME);
          }

          return result;
      });
    }

    this.noCapa =  [ITPS.INVESTIGATION_INSPECTION, ITPS.INFORMAL_MARKET_INSPECTION].indexOf(inspectionTypeCode) > -1;
  }

  inspectionDocPreviewModal(fileName, documentId){
      const attachmentUrl = SubDataVariables.INSPECTION_DOC_URL + '/' + documentId;
      this.previewService.openModal(attachmentUrl, fileName, true);
  }

  odkPreviewModal(inspectionResult : InspectionResult){
    // the new inspection result from odk virtual form
    this.currentInspectionResult = inspectionResult;
    this.showEnketoForm = true;
  }

  isInspectionLegacyData(){
    return this.inspection.isLegacyData;
  }

  isLetterGenerated(){
    let statusCode = this.inspection.status.inspectionStatusCode;
    let letterGenertedStatuses = [IST.PRODUCT_RECALLED_CODE, IST.LICENSE_CANCELLED_CODE,
      IST.LICENSE_SUSPENDED_CODE, IST.WARNING_GIVEN_CODE, IST.FORWARDED_FOR_FOLLOW_UP_INSPECTION,
      IST.RETURN_TO_APPLICANT, IST.SCREENING_FAILED, IST.NON_COMPLIANCE_LETTER_GENERATED, IST.APPROVAL_LETTER_GENERATED_WITH_CAPA, IST.REJECTED];

    if(letterGenertedStatuses.findIndex(m => m === statusCode) != -1 || (!this.isGMP && statusCode == IST.APPROVAL_LETTER_GENERATED_CODE)){
      return true;
    }
    return false;
  }

  isPartialLetterGenerated(){
    let statusCode = this.inspection.status.inspectionStatusCode;
    if(statusCode == IST.PARTIAL_APPROVAL_LETTER_GENERATED_CODE){
      return true;
    }
    return false;
  }

  isSupportLetterGenerated(){
    let statusCode = this.inspection.status.inspectionStatusCode;
    if(this.isGMP && [IST.PARTIAL_APPROVAL_LETTER_GENERATED_CODE, IST.APPROVAL_LETTER_GENERATED_CODE, IST.CAPA_PLAN_REQUESTED, IST.CAPA_PLAN_SUBMITTED].indexOf(statusCode) != -1
      && this.getDocument(this.constants.SUPPORT_LETTER_REFERENCE_ID)){
      return true;
    }
    return false;
  }

  showGeneratedLetter(){
    let attachmentUrl = SubDataVariables.INSPECTION_LETTER_URL + '/' + this.inspection.id;
    this.previewService.openModal(attachmentUrl, "Generated Letter" , true);
  }

  showGeneratedCertificate(){
    let attachmentUrl = SubDataVariables.GMP_CERTIFICATE_URL + '/' + this.inspection.id;
    this.previewService.openModal(attachmentUrl, "Generated Certificate" , true);
  }

  isCertificateGenerated(){
    return this.isGMP && [IST.APPROVAL_LETTER_GENERATED_CODE, IST.PARTIAL_APPROVAL_LETTER_GENERATED_CODE, IST.CAPA_PLAN_REQUESTED, IST.CAPA_PLAN_SUBMITTED].indexOf(this.inspection.status.inspectionStatusCode) !== -1;
  }

  showDeficiencyLetter(){
    const attachmentUrl = SubDataVariables.DEFICIENCY_LETTER_URL + '/' + this.inspection.id;
    this.previewService.openModal(attachmentUrl, "Letter", true);
  }

  isFieldEdited() {
    if(this.inspection.differentProductionLine){
      return {'highlight-text': true};
    }
  }

  isFileAttached(docRefID) {
    const idx = this.attachedDocs.map(doc => {
      return doc.referenceID;

    }).findIndex((elt) => {

      return elt === docRefID;
    });
    if (idx !== -1) {
      return true;
    } else {
      return false;
    }
  }

  previewModal(modalName: string, docRefID: number, fileIndex: number) {
    let doc = this.getDocument(docRefID)
    const attachmentUrl = SubDataVariables.INSPECTION_DOC_URL + '/' + doc.id;
    this.previewService.openModal(attachmentUrl, modalName, true);
  }

  getDocument(docRefID) {
    const idx = this.attachedDocs.map(doc => {
      return doc.referenceID;

    }).findIndex((elt) => {

      return elt === docRefID;
    });

    if (idx !== -1) {
      return this.attachedDocs[idx];
    } else {
      return null;
    }
  }

  downloadAttachment(name: string, docRefID: number, fileIndex: number) {
    let  doc = this.getDocument(docRefID);

    this.inspectionService.getAttachmentByID(doc.id).subscribe(data => {
      const blob = new Blob([data], {
        type: 'application/pdf'
      });
      saveAs(blob, name);
    });
  }

  getFileName(docRefID, fileIndex) {
    let doc = this.getDocument(docRefID);
    if (doc) {
      let fileName = doc.filePath.replace(/^.*[\\\/]/, '');
      if (!fileName.length) {
        fileName = '-';
      }
      return fileName;
    }
    return '-';
  }

  getUploadTime(docRefID, fileIndex) {
    let doc = this.getDocument(docRefID);

    if (doc) {
      return this.getDateString(doc.modifiedDate);
    }

    return '-';
  }

  getRecieptNumber(docRefID, fileIndex) {
    if (docRefID === Constants.PAYMENT_REFERENCE_ID || docRefID === Constants.GMP_FINAL_PAYMENT_REFERENCE_ID) {
      let doc = this.getDocument(docRefID);
      if (doc) {
        const paymenInfo = this.inspection.inspectionPayment.find(function (x) {
          return x.documentID === doc.id;
        });
        if (paymenInfo) {
          return paymenInfo.recieptNumber;
        }
      }
    }

    return '';
  }

  getInspectionHistory(id) {
    if (!id) return;
    this.inspectionService.getInspectionHistory(id).subscribe(res => {
      this.historyLog = Array.isArray(res) ? res : [];
    }, err => {
      console.error('getInspectionHistory failed', err);
      this.historyLog = [];
    });
  }

  onEnketoFormClosed(closed: boolean){
    if(closed){
      this.showEnketoForm = false;
    }
  }

  addPaymentLetter(){
    var paymentDoc = this.attachedDocs.find(doc => doc.documentReference.name == "Payment Request")
    if (paymentDoc){
      var paymentDocRef = paymentDoc.documentReference
      this.documentRefs.push(paymentDocRef)
    }
  }

  getCapaDueDate(){
    let capas = this.inspection.inspectionCapas.sort((a, b) => b.id - a.id); //latest capa first
    if(capas.length > 0 && capas[0].capaDueDate){
      return this.getDateString(capas[0].capaDueDate);
    }
    return null;
  }

  getImplementationReportDueDate(){
    let capas = this.inspection.inspectionCapas.sort((a, b) => b.id - a.id);
    if(capas.length > 0 && capas[0].implementationReportDueDate){
      return this.getDateString(capas[0].implementationReportDueDate);
    }
    return null;
  }

  isInCapaPlanPhase(){
    return [IST.CAPA_PLAN_REQUESTED, IST.CAPA_PLAN_SUBMITTED, IST.CAPA_PLAN_REJECTED]
      .indexOf(this.inspection.status.inspectionStatusCode) !== -1;
  }

  isInCapaImplementationPhase(){
    return [IST.IMPLEMENTATION_REPORT_REQUESTED, IST.IMPLEMENTATION_REPORT_SUBMITTED, IST.IMPLEMENTATION_REPORT_REJECTED]
      .indexOf(this.inspection.status.inspectionStatusCode) !== -1;
  }

  getInspectionStartDate(data: InspectionAssignment[]) {
    let assignment = data.find(d => d.primary == true && d.assignmentType == "INSPECTION");
    if(assignment && assignment.startDate){
      return this.getDateString(assignment.startDate)
    }
  }

  getInspectionDueDate(data: InspectionAssignment[]) {
    let assignment = data.find(d => d.primary == true && d.assignmentType == "INSPECTION");
    if(assignment && assignment.dueDate) {
      return this.getDateString(assignment.dueDate)
    }
  }

  fillKeyPersons() {
    const abroadFacility = this.inspection?.inspectionAbroadFacility?.[0]?.abroadFacility;
    if (!abroadFacility) {
      this.keyPersons = [];
      return;
    }
    let types = ["Manufacturer Contact", "Quality Assurance", "Quality Control", "Product Manager", "International Marketing",
      "Regularity Affair", "Owner"]

    for(let type of types) {
      let fieldNamePrefix = type.split(" ").map((word, index) => (index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())).join("");
      let obj = {};
      obj["name"] = abroadFacility[fieldNamePrefix+"Name"];
      if(!obj["name"]) {
        continue;
      }
      obj["email"] = abroadFacility[fieldNamePrefix+"Email"];
      obj["phone"] = abroadFacility[fieldNamePrefix+"Phone"];
      obj["type"] = type;
      this.keyPersons.push(obj);
    }
  }

  closeModal() {
    this.modalRef.hide();
  }

  isExpanded(prodDetailId: number) {
    const index = this.expandedProdDetailIds.findIndex(id => id === prodDetailId);
    return index !== -1;
  }

  expandOffsiteInfo(prodDetailId: number) {
    const index = this.expandedProdDetailIds.findIndex(id => id === prodDetailId);
    if (index !== -1) {
      return;
    }

    this.expandedProdDetailIds.push(prodDetailId);
  }

  collapseOffsiteInfo(prodDetailId: number) {
    const index = this.expandedProdDetailIds.findIndex(id => id === prodDetailId);

    if (index !== -1) {
      this.expandedProdDetailIds.splice(index, 1);
    }
  }

  joinLookupTypes(array: any[]) {
    if(!array || array.length == 0) {
      return "-";
    }
    return array.map(q => q.name).join(" , ");
  }
  getDosageForms(): string {
    const dosageForms = this.inspection.productionInfo.prodInfoDosageForms;
    return dosageForms.length > 0 ? this.joinLookupTypes(dosageForms.map(a => a.dosageForm)) : '-';
  }
}
